function truncateText(text = '', length: number) {
  return text.length > length 
  ? `${text.slice(0, length)}...` 
  : text;
}

export default truncateText;
